import { requestGscApi } from '../GscTools/request';

/**
 * Lists the sitemaps submitted for one property — or, with `sitemapIndex`, the ones submitted
 * inside that index — through the Sitemaps endpoint, with the OAuth credentials linked to
 * `credentialsDomainId`.
 *
 * One request, read-only. The sitemap files themselves are never fetched: everything this report
 * shows is the submission record Search Console returns.
 */
export function listSitemaps({ credentialsDomainId, siteUrl, sitemapIndex = '' }) {
    const params = { domain_id: credentialsDomainId, site_url: siteUrl };
    if (sitemapIndex) params.sitemap_index = sitemapIndex;

    return requestGscApi('/api/v1/domains/gsc-sitemaps/', { params });
}
